import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { FileDownloadUrlResponse } from '@/repositories/generated';

const response: FileDownloadUrlResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['外部企業ID', '外部店舗ID', '外部端末ID', 'QR端末/ステッカーID', '利用開始日', '利用終了日'],
    ['1', '1', '1', '1', '2023-01-01', '2023-01-01'],
  ]),
};

export const bulkImportDownloadOriginal = http.get(
  createMockEndpoint('/bulk_import/:id/download/original'),
  async ({ params }) => {
    if (params.id === '7') {
      return HttpResponse.json({
        error: {
          code: 'ERR-D999-0007',
          message: 'URLが間違っているか、ページが存在しません。',
        },
      }, { status: 404 });
    }
    await delay(500);

    return HttpResponse.json(response, { status: 200 });
  },
);
